module.exports = __webpack_public_path__ + "img/logo_vertical.8e91aa54.png";